import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { locale } from 'beans-admin-plugin';
import _ from 'lodash';
import Element from 'element-ui';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementFrLocale from 'element-ui/lib/locale/lang/fr';
import localeEn from '@/locales/en';
import localeFr from '@/locales/fr';
import adminEn from '@/admin_i18n/en';
import adminFr from '@/admin_i18n/fr';

Vue.use(VueI18n);

const messages = {
  en: _.merge(
    adminEn,
    localeEn
  ),
  fr: _.merge(
    adminFr,
    localeFr
  ),
}

const localeStorageKey = require('./admin-plugin-config').default.i18n.localeStorageKey;

let defaultLocale = _.snakeCase(navigator.language);
defaultLocale = defaultLocale.includes('en_') ? 'en' : defaultLocale;
defaultLocale = messages[defaultLocale] ? defaultLocale : 'en';

export const i18n = new VueI18n({
  locale: localStorage.getItem(localeStorageKey) || defaultLocale,
  fallbackLocale: defaultLocale,
  messages: _.merge({}, {
    fr: locale['fr'],
    en: locale['en']
  }, {
    fr: elementFrLocale,
    en: elementEnLocale,
  }, messages)
});

document.title = i18n.t('documentTitle')

window.onload = function () {
  window.CKEDITOR.config.language = {
    en: 'en',
    fr: 'fr',
  }[i18n.locale]
}

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
});
